import section1 from './content/section-01/section-01-section';
import section2 from './content/section-02/section-02-section';
import section3 from './content/section-03/section-03-section';

export default {
  sections: [
    section1,
    section2,
    section3
  ]
}